var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-divider", {
        attrs: { label: "Documentação", tooltip: _vm.informacao }
      }),
      _vm.pecasTecnicas && _vm.tipoSelecionado
        ? _c(
            "el-alert",
            { attrs: { title: _vm.tipoSelecionado.descricao, type: "info" } },
            [
              _c("br"),
              _c("small", [
                _vm._v(
                  _vm._s(
                    _vm.mensagensTipoDocumento[_vm.tipoSelecionado.codigo].texto
                  )
                )
              ])
            ]
          )
        : _vm._e(),
      _c("app-upload-documentos-anexar", {
        attrs: {
          modulo: _vm.modulo,
          "valid-extensions": _vm.validExtensions,
          "max-size": _vm.maxSize,
          scope: _vm.scope,
          validateCampos: _vm.validateCampos,
          "validation-name": _vm.validationName,
          validateDocumentos: _vm.validateDocumentos,
          mutationAddDocumento: _vm.mutationAddDocumento,
          getterTiposDocumentos: _vm.getterTiposDocumentos,
          findTiposDocumento: _vm.findTiposDocumento
        },
        on: {
          tipoChanged: function($event) {
            _vm.tipoSelecionado = $event
          }
        }
      }),
      _c("el-row", [
        _c(
          "div",
          {
            staticClass: "input",
            class: { erro: _vm.errors.has(_vm.getFieldName("Documentos")) }
          },
          [
            _c(
              "el-table",
              { attrs: { data: _vm.documentos, stripe: "stripe" } },
              [
                _c("div", { attrs: { slot: "empty" }, slot: "empty" }, [
                  _c("span", [
                    _vm._v(
                      'Nenhum arquivo adicionado. Para adicionar um novo arquivo, clique no botão "Anexar" acima.'
                    )
                  ])
                ]),
                _c("el-table-column", {
                  attrs: {
                    prop: "tipoDocumento.descricao",
                    label: "Tipo de documento",
                    align: "left"
                  }
                }),
                _c("el-table-column", {
                  attrs: { prop: "nome", label: "Anexos" }
                }),
                _c("el-table-column", {
                  attrs: { label: "Ações", align: "center", width: "80" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("app-action-button", {
                            attrs: {
                              icone: "times",
                              cor: "#CF0021",
                              text: "Remover documento"
                            },
                            on: {
                              click: function($event) {
                                return _vm.deleteRow(scope.row)
                              }
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.errors.has(_vm.getFieldName("Documentos")),
              expression: "errors.has(getFieldName('Documentos'))"
            }
          ],
          staticClass: "help erro"
        },
        [
          _c("pre", [
            _vm._v(_vm._s(_vm.errors.first(_vm.getFieldName("Documentos"))))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e2f3ae1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e2f3ae1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppUploadDocumentos.vue
// module id = null
// module chunks = 